import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
`;

export const Title = styled.div`
  width: 100%;
  padding: var(--fd-space-space-6) var(--fd-space-space-4);
  border-bottom: 1px solid var(--fd-colors-border-default);
  background: var(--fd-colors-background-surface);
`;

export const Columns = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: var(--fd-space-space-4);
  gap: var(--fd-space-space-4);
  background: var(--fd-colors-background-base);

  @media screen and ${breakpoints.tablet.min.sm} {
    flex-direction: row;
  }
`;

const gap = 16;
const sideWidth = 325;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--fd-space-space-3);

  @media screen and ${breakpoints.tablet.min.sm} {
    width: calc(100% - ${sideWidth + gap}px);

    &:only-child {
      width: 100%;
      max-width: 651px;
      margin: 0 auto;
    }
  }
`;

export const SideContent = styled.div`
  width: ${sideWidth}px;
`;

export const LatestVideos = styled.div`
  background: var(--fd-colors-background-surface);
  border-bottom: 1px solid var(--fd-colors-border-subtle);
`;
